import { CountryCurrencyMapping } from '@dupe/common/types'

export const RECAPTCA_ID = 'phoneRecaptcha'

export const DUPE_SUPPORTED_COUNTRIES_MAPPING: CountryCurrencyMapping = {
  us: {
    name: 'US',
    value: 'us',
    flag: '🇺🇸',
    currency_symbols: ['USD', 'US$', '$'],
  },
  ca: {
    name: 'CA',
    value: 'ca',
    flag: '🇨🇦',
    currency_symbols: ['C', 'CAD', 'C$', 'CAD$', '$'],
  },
  gb: {
    name: 'UK',
    value: 'gb',
    flag: '🇬🇧',
    currency_symbols: ['£', '€'],
  },
  au: {
    name: 'AU',
    value: 'au',
    flag: '🇦🇺',
    currency_symbols: ['A', 'A$', '$'],
  },
  nz: {
    name: 'NZ',
    value: 'nz',
    flag: '🇳🇿',
    currency_symbols: ['N', 'NZD', 'NZ$', '$'],
  },
}

export const TEMP_USER_ID_KEY = '__dupe_temp_user_id'
export const DUPE_AUTH_USER_ID_KEY = '__dupe_auth_user_id'
export const DUPE_SESSION_COOKIE_KEY = '__dupe_session'
export const DUPE_FLAGS_COOKIE_KEY = '__dupe_flags'
export const MAX_AGE_OF_COOKIE = 60 * 60 * 24 * 365 // one year in seconds

export const IMAGEKIT_URL_ENDPOINT = 'https://ik.imagekit.io/carrot/'
export const IMAGEKIT_PUBLIC_KEY = process.env.NEXT_PUBLIC_IMAGEKIT_PUBLIC_KEY
export const IMAGEKIT_PRIVATE_KEY = process.env.IMAGEKIT_PRIVATE_KEY

// For new Imagekit account
export const IMAGEKIT_DUPE_URL_ENDPOINT = 'https://ik.imagekit.io/dupe/'
export const IMAGEKIT_DUPE_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_IMAGEKIT_DUPE_PUBLIC_KEY
export const IMAGEKIT_DUPE_PRIVATE_KEY = process.env.IMAGEKIT_DUPE_PRIVATE_KEY

export const DEFAULT_LOADING_COPY = [
  'Detecting product',
  'Assessing similarities',
  'Scanning partner sites',
  'Removing duplicates',
  'Doing one more pass',
  'This is a tough product',
  'Hang tight, friend!',
]

export const PRODUCT_RESULTS_PER_PAGE = 24
